module.exports = __webpack_public_path__ + "img/contributions3On.de355d19.svg";